import label from './label';

export default label;
